
<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol style="font-size: 25px;" col="6">
                الطلاب
            </CCol>
        </CRow>
        </CCardHeader>
        <CCardBody>
          <!-- Using the VdtnetTable component -->
          <vdtnet-table
            ref="table"
            :fields="fields"
            :opts="options"
            @edit="doAlertEdit"
            @show="doAlertShow"
            @block="doAlertBlock"
            @reloaded="doAfterReload"
            @table-creating="doCreating"
            @table-created="doCreated"
          >
          </vdtnet-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import swal from 'sweetalert'
import VdtnetTable from '../VdtnetTable.vue'

export default {
  name: 'Categories',
  components: { VdtnetTable },
  data () {
    return {
      options: {
        ajax: {
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              'Authorization',
              'Bearer ' + localStorage.token
            )
          },
          url: this.$hostUrl + 'students',
          dataSrc: (json) => {
            return json.data
          }
        },
        buttons: [
          // {
          //   extend: 'collection',
          //   text: 'Table control',
          //   buttons: [
          //     {
          //       text: 'paied',
          //       action: function (e, dt, node, config) {
          //         dt.column(-2).visible(!dt.column(-2).visible())
          //       }
          //     },
          //     {
          //       text: 'unpaied',
          //       action: function (e, dt, node, config) {
          //         dt.column(-1).visible(!dt.column(-1).visible())
          //       }
          //     }
          //   ]
          // },
          {
            extend: 'print',
            text: '',
            titleAttr: 'طباعة',
            className: 'fa fa-print btn-primary',
            exportOptions: {
              // columns: 'th:not(:last-child)'
              columns: [1, 2, 3, 4]
            }

          },
          {
            extend: 'copy',
            text: '',
            className: 'fa fa-copy btn-warning',
            titleAttr: 'نسخ',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          },
          {
            extend: 'excel',
            text: '',
            titleAttr: 'إكسل',
            className: 'fa fa-table btn-success',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          }
        ],
        dom:
          "<'row'<'col-sm-6 col-md-6'f><'col-sm-6 col-md-6 added'l>>" +
          "<'row'<'col-sm-12'Btr>>" +
          "<'row'<'col-sm-12 col-md-8'p><'col-sm-12 col-md-4'i>>",
        paging: true,
        language: {
          url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/Arabic.json'
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        saveState: true,
        select: {
          style: 'multi'
        }
      },
      fields: {
        id: {
          label: 'رقم الطالب',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        first_name: {
          label: 'الإسم الأول',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        last_name: {
          label: 'الإسم الثاني',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        mobile: {
          label: 'رقم الهاتف',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        created_at: {
          label: 'تاريخ الإنشاء',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        block: {
          label: 'حظر',
          sortable: true,
          searchable: false,
          exportOptions: {
            visible: false
          }
        },
        actions: {
          isLocal: true,
          label: 'العمليات',
          defaultContent: '<button href="javascript:void(0);" data-action="show" class="btn btn-info btn-sm" title="عرض الطالب"><i class="mdi mdi-square-show-outline"></i> عرض</button>'
        }
      },
      quickSearch: '',
      details: {}
    }
  },
  created () {

  },
  methods: {
    doLoadTable (cb) {
      this.$http.getJSON(
        this.$hostUrl + 'students',
        function (data) {
          cb(data.data)
        }
      )
    },
    doAlertShow (data) {
      this.$router.push({ path: `/students/${data.id}/show`, params: { id: data.id } })
    },
    doAlertEdit (data) {
      this.$router.push({
        path: `/students/${data.id}/edit`,
        params: { id: data.id }
      })
    },
    doAlertBlock (data, row, tr, target) {
      console.log(`deleting item ID: ${data.id}`)
      // for change swal tex
      let customText
      if (data.blocked === '0') {
        customText = 'سيتم حظر صاحب الحساب من تسجيل الدخول'
      } else if (data.blocked === '1') {
        customText = 'سيتم فك الحظر'
      }
      swal({
        title: 'هل انت متأكد ؟',
        text: customText,
        icon: 'warning',
        buttons: ['لا', 'نعم'],
        dangerMode: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((willDelete) => {
        if (willDelete) {
          this.$http
            .get(
              `${this.$hostUrl}students/${data.id}/block`,
              { _method: 'get' }
            )
            .then((response) => {
              console.log(response)
              swal({ title: response.data.message, buttons: 'تم' })
            })
          tr.remove()
          const table = this.$refs.table
          setTimeout(() => {
            table.reload()
          }, 1500)
        } else {
          swal({ title: ' تم الغاء العملية !', buttons: 'تم' })
        }
      })
    },
    doAfterReload (data, table) {
      console.log('data reloaded')
    },
    doCreating (comp, el) {
      console.log('creating')
    },
    doCreated (comp) {
      console.log('created')
    },
    doSearch () {
      this.$refs.table.search(this.quickSearch)
    },
    doExport (type) {
      const parms = this.$refs.table.getServerParams()
      parms.export = type
    },
    formatCode (zipcode) {
      return zipcode.split('-')[0]
    }
  }
}
</script>
